import React from 'react';
import { Timestamp } from 'shared/types/timestamp';
import { CalendarViewOptions } from 'shared/types/upcoming-view-options';

import { FourDay } from '../four-day';
import { Month } from '../month';
import { Week } from '../week';

export type CalendarViewProps = {
  view: CalendarViewOptions;
  referenceDate: Timestamp;
  scrollTime: string;
};

export const CalendarView: React.FC<CalendarViewProps> = ({
  view,
  referenceDate,
  scrollTime,
}) => (
  <>
    {view === CalendarViewOptions.FourDay && (
      <FourDay rangeReferenceDate={referenceDate} scrollTime={scrollTime} />
    )}

    {view === CalendarViewOptions.Week && (
      <Week rangeReferenceDate={referenceDate} scrollTime={scrollTime} />
    )}

    {view === CalendarViewOptions.Month && (
      <Month referenceDate={referenceDate} />
    )}
  </>
);
